import React from "react";
import "./navbar.css";
import { Link } from "react-router-dom";
  import Logo from '../../assets/img/logo-eja-600x600.png';
  
const Navbar = ({ logout }) => {

  return (
    <header className="p-3 mb-3 border-bottom">
      <div className="container">
        <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
          <a
            href="/"
            className="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none"
          >
            {/* <svg className="bi me-2" width="40" height="32" role="img" aria-label="Bootstrap"><use xlink:href="#bootstrap"/></svg> */}
          </a>

          <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
            <li>
                <Link to="/" className="nav-link px-2 link-secondary">
                  Inicio
                </Link>
            </li>
            {/* <li>
                <Link to="#visitedPages" className="nav-link px-2 link-dark">
                  Páginas visitadas
                </Link>
            </li> */}
            {/*<li><a href="#" className="nav-link px-2 link-dark">Customers</a></li>
                <li><a href="#" className="nav-link px-2 link-dark">Products</a></li> */}
          </ul>

          {/* <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3" role="search">
                <input type="search" className="form-control" placeholder="Search..." aria-label="Search" />
                </form> */}

          <div className="dropdown text-end">
            <span
              className="d-block link-dark text-decoration-none dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={Logo}
                alt="mdo"
                width="32"
                height="32"
                className="rounded-circle"
              />
            </span>
            <ul className="dropdown-menu text-small">
              {/* <li>
                <Link to="/" className="nav-link px-2 link-dark">
                    Dashboard
                </Link>
              </li>
              <li className="dropdown-divider"></li>
              <li>
                <Link to="/paginas-visitadas" className="nav-link px-2 link-dark">
                    Páginas visitadas
                </Link>
              </li> 
              <li className="dropdown-divider"></li>*/}
              <li>
                <span className="dropdown-item" onClick={logout}>
                  Cerrar sesión
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
